import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Invitation } from '../invitation';
import * as dateFormat from 'dateformat';
import { ProfileManager, ProfileContext } from '../profile';
import { APIRequest, useRequestAsync, getHeaders } from '../api/client';

const DATE_FORMAT = 'd mmmm, yyyy - HH:MM:s';

export interface Props {
  invitation: Invitation;
  index: number;
}

const deleteInvitation = (
  context: ProfileManager,
  id: string,
): [APIRequest, Function] =>
  useRequestAsync(() => ({
    url: `/invitations/${id}`,
    method: 'DELETE',
    body: JSON.stringify({}),
    headers: getHeaders(context),
  }));

export default function InvitationListItem(props: Props) {
  const context: any = React.useContext(ProfileContext);
  const [state, submit] = deleteInvitation(context, props.invitation.id);

  if (state.data && state.complete) {
    return <Redirect to="/invitations" />;
  }

  return (
    <div
      className={`flex justify-stretch items-center pv2 pv3-ns ${
        props.index > 0 ? 'bt b--black-10' : ''
      }`}
    >
      <div className="mr4 flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Name</h4>
        <p className="lh-title ma0 mb2">{props.invitation.name}</p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Email</h4>
        <p className="lh-title ma0 mb2">{props.invitation.email}</p>
      </div>
      <div className="mr3 flex-auto">
        <h4 className="lh-copy ma0 mb2 f7 black-50 ttu">Sent at</h4>
        <p className="lh-title ma0 mb2">
          {dateFormat(props.invitation.created_at, DATE_FORMAT)}
        </p>
      </div>
      <div className="flex-auto tr">
        <Link
          to={{
            pathname: `/invitations/${props.invitation.id}/delete`,
            state: {
              invitation: props.invitation,
            },
          }}
          className="link red b mh3"
          onClick={() => submit()}
        >
          Delete
        </Link>
      </div>
    </div>
  );
}
